import { render, staticRenderFns } from "./searchInfoVant.vue?vue&type=template&id=16d5f44c&scoped=true&"
import script from "./searchInfoVant.vue?vue&type=script&lang=js&"
export * from "./searchInfoVant.vue?vue&type=script&lang=js&"
import style0 from "./searchInfoVant.vue?vue&type=style&index=0&id=16d5f44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d5f44c",
  null
  
)

export default component.exports